import FAQSection from '../../components/sections/FAQSection';
import JoinSection from '../../components/sections/JoinSection';
import { ContactFormSection, GetInTouchSection } from './components';

/**
 * Contact page for Konnect Better.
 *
 * Surfaces contact methods, the community sign-up form, a direct message form,
 * and an FAQ section. Routes to /joincommunity so existing "Join Community" links
 * resolve here.
 */
export default function ContactPage() {
  return (
    <main>
      <GetInTouchSection />
      <JoinSection useInitialAnimation={true} />
      <ContactFormSection />
      <FAQSection />
    </main>
  );
}
